import { DayOfWeek } from "@js-joda/core";
export class DateUtil {
    static isSameDay(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }
    static getDayOfWeek(date) {
        const jsDay = date.getDay();
        // JS: 0=Sunday, 1=Monday, ..., 6=Saturday
        // JS-Joda: 1=Monday, ..., 7=Sunday
        return jsDay === 0 ? DayOfWeek.SUNDAY : DayOfWeek.of(jsDay);
    }
}
